import { Component } from '@angular/core';

@Component({
    selector: 'app-kb-software-neosearch-page',
    templateUrl: './kb-software-neosearch-page.component.html',
    styleUrls: ['./kb-software-neosearch-page.component.scss'],
    standalone: false
})
export class KbSoftwareNeosearchPageComponent {

}
